// Meta Skill hierarchy data matching the skill builder structure
// Used for linking skill bites and content to accelerate journey skills
export const META_SKILL_OPTIONS = [
  {
    value: 'ms-wwy4n',
    label: 'Emotional Intelligence',
    skills: [
      { value: 's-csfldo', label: 'Social Sensitivity' },
      { value: 's-bptsv4', label: 'Empathy' },
      { value: 's-ob0s8p', label: 'Self-Awareness / Self-Regulation' }
    ]
  },
  {
    value: 'ms-vz6ip',
    label: 'Set Expectations',
    skills: [
      { value: 's-zihtkn', label: 'Delegation' },
      { value: 's-084kjr', label: 'Goal Setting' },
      { value: 's-9xeyiq', label: 'Transparent Communication' }
    ]
  },
  {
    value: 'ms-2r1om',
    label: 'Develop People',
    skills: [
      { value: 's-52m43k', label: 'Coaching' },
      { value: 's-ixjamx', label: 'Guidance' },
      { value: 's-te3hg8', label: 'Active Listening' }
    ]
  },
  {
    value: 'ms-5li0a',
    label: 'Motivate People',
    skills: [
      { value: 's-b9ko1v', label: 'Recognition' },
      { value: 's-cmvwz4', label: 'Trust' },
      { value: 's-nt6q2v', label: 'Inclusive Leadership' }
    ]
  }
]
